import React from "react";

import Dasboart from "./dasboart.jsx"
//import Footer from "./footer.jsx";
 

class Main extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Dasboart/>
            </React.Fragment>
            
        )
    }

}

export default Main;